import React from 'react';
import { AdvancedImage } from '@cloudinary/react';
import { Cloudinary } from "@cloudinary/url-gen";
import { format } from '@cloudinary/url-gen/actions/delivery';
import companyLogo from '@assets/images/logo-white.svg';

function CommonUnlockModal({ classname, handleCloseUnlockModal, signInHandle }) {

    const cld = new Cloudinary({
        cloud: {
            cloudName: 'dci1aiukm'
        }
    });

    const myImage = cld.image('login-img').quality('auto').delivery(format('webp'));

    return (
        <>
            <div className={`${classname}`}>
                <div className='bs-banner-form__media-wrap'>
                    <AdvancedImage cldImg={myImage} loading="lazy" className='bs-banner-form__image' />
                    <div className='bs-banner-form__logo'>
                        <img width="100%" height="100%" src={companyLogo} alt="Company logo" />
                    </div>
                </div>
                <div className='bs-banner-form__cont-wrap'>
                    <div className="bs-success-msg bs-success-msg--typ-2">
                        <div className='bs-success-msg__info-wrap'>
                            <h4 className='bs-success-msg__title'>Step Into the World of SANSAAR</h4>
                            <h6 className='bs-success-msg__sub-title'>Thoughtfully made. Mindfully curated</h6>
                            <p className='bs-success-msg__desc'>Be the first to discover our new collections, stories of craft, and the journey toward conscious living.</p>
                        </div>
                        <div className='bs-success-msg__action-wrap'>
                            <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl bs-success-msg__primary-cta' onClick={signInHandle}>Sign up</button>
                            <div className='mod-text-btn'>
                                <p className='mod-text-btn__text'>already a user? <button className='bs-btn bs-btn__btn-link mod-text-btn__link' onClick={signInHandle}>login now</button></p>
                            </div>
                            <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl bs-btn__btn-solid--inverse-border bs-success-msg__secondary-cta' onClick={() => handleCloseUnlockModal()}>continue as a guest</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CommonUnlockModal